import clsx from 'clsx';
import React from 'react';

interface CardActionsProps {
  children?: React.ReactNode;
  position?: 'start' | 'center' | 'end' | 'spacing';
  className?: string;
}

export const CardActions: React.FC<CardActionsProps> = ({
  children,
  position = 'end',
  className,
}) => {
  return (
    <div className={clsx(
      "flex pt-4 gap-2",
      position === 'end' && "justify-end",
      position === 'center' && "justify-center",
      position === 'spacing' && "justify-between",
      className
    )}>
      {children}
    </div>
  )
};